export default "__VITE_ASSET__DZIeDrUX__"